export function b64DecodeUnicode(str: string) {
  return decodeURIComponent(
    Array.prototype.map
      .call(atob(str), function (c) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
      })
      .join(''),
  );
}

interface ParsedEmailContent {
  email: string;
  subject: string;
  body: string;
}

export function parseEmailContent(
  content: string,
): ParsedEmailContent {
  const emailMatch = content.match(
    /EMAIL:\s*([\s\S]*?)(?=\s+Betreff:|Betreff:|$)/,
  );
  const subjectMatch = content.match(
    /Betreff:\s*([\s\S]*?)(?=\s+NUTZEREINGABE:|NUTZEREINGABE:|$)/,
  );
  const bodyMatch = content.match(/NUTZEREINGABE:\s*([\s\S]*)$/);

  return {
    email: emailMatch?.[1]?.trim() ?? '',
    subject: subjectMatch?.[1]?.trim() ?? '',
    body: (bodyMatch?.[1]?.trim() ?? '')
      .split('\n')
      .filter((line) => line.trim() !== '')
      .join('\n'),
  };
}

export function generateRandomString(length: number): string {
  const array = new Uint8Array(length);
  crypto.getRandomValues(array);
  return Array.from(array, (byte) =>
    byte.toString(16).padStart(2, '0'),
  )
    .join('')
    .slice(0, length);
}

export function sanitizeApplicationName(input: string): string {
  let name = input.toLowerCase();
  // Replace all invalid characters with dashes (except letters, numbers, dash, underscore)
  name = name.replace(/[^a-z0-9-_]+/g, '-');
  // Remove leading characters until we find a letter
  name = name.replace(/^[^a-z]+/, '');
  // If the name is now empty or doesn't start with a letter, prefix with 'a'
  if (!name || !/^[a-z]/.test(name)) {
    name = 'a' + name;
  }
  return name;
}
